import React from "react";
import CheckBox from "../components/checkBox";

class FilterItem extends React.Component {
  state = {
    panelsActive: [],
    linesActive: [],
    lightActive: [],
    bifold: false,
    arch: false,
    hasSubFilters: false
  };

  render() {
    const { isActive, name, subCat } = this.props;
    const props = this.props;
    let hasSubFilters = false;

    if (subCat['panel'] || subCat['line'] || subCat['light'] || subCat['arc'] || subCat['bifold']) {
      hasSubFilters = true
    }

    return (
      <div className={`filter-item ${isActive ? 'active' : ''} ${isActive && hasSubFilters ? 'filter-item--open' : ''}`} onClick={() => { props.filterClicked(name); }}>
        <div className="filter-item__name" onClick={() => {
          props.activeFilter(name);
          if (hasSubFilters) {
            props.triggerFilter(name)
          } else {
            props.triggerFilter(name)
          }
        }}>
          <h2>{name}</h2>
          {hasSubFilters &&
            <i>{isActive ? <img src={`/wp-content/themes/uniform_base/assets/img/app/icon-minus.svg`} alt="Close" /> : <img src={`/wp-content/themes/uniform_base/assets/img/app/icon-plus.svg`} alt="Open" />}</i>
          }
        </div>

        {isActive && hasSubFilters &&
          <div className="filters">
            {subCat['light'] && <h3 className="filter-heading">Panes</h3>
            }
            {subCat['light'] &&
            <div className="sub-filter sub-filter--panels">
              {subCat['light'].sort((a, b) => {
                if(Number(a) && Number(b))  {
                  a = Number(a)
                  b = Number(b)
                }
                return a === b ? 0 : a < b ? -1 : 1;
              }
              ).map((item) => {
                return <div key={item}
                  onClick={() => {
                    if (this.state.lightActive.includes(item)) {
                      this.setState({
                        lightActive: this.state.lightActive.filter(e => e !== item)
                      }, () => props.triggerFilter(name, this.state.panelsActive, this.state.linesActive, this.state.lightActive, this.state.bifold, this.state.arch))
                    } else {
                      this.setState(prevState => ({
                        lightActive: [item, ...prevState.lightActive]
                      }), () => props.triggerFilter(name, this.state.panelsActive, this.state.linesActive, this.state.lightActive, this.state.bifold, this.state.arch))
                    }
                  }}>
                  <CheckBox name={item} filterName={'Light'} active={this.state.lightActive.includes(item)} />
                </div>
              })}
            </div>
            }
            {subCat['panel'] && <h3 className="filter-heading">Panels</h3>}
            {subCat['panel'] &&
            <div className="sub-filter sub-filter--panels">
              {subCat['panel'] && subCat['panel'].sort((a, b) => a - b).map((item) => {
                return <div key={item}
                  onClick={() => {
                    if (this.state.panelsActive.includes(item)) {
                      this.setState({
                        linesActive: [],
                        panelsActive: this.state.panelsActive.filter(e => e !== item)
                      }, () => props.triggerFilter(name, this.state.panelsActive, null, this.state.lightActive, this.state.bifold, this.state.arch))
                    } else {
                      this.setState(prevState => ({
                        linesActive: [],
                        panelsActive: [item, ...prevState.panelsActive]
                      }), () => props.triggerFilter(name, this.state.panelsActive, null, this.state.lightActive, this.state.bifold, this.state.arch))
                    }
                  }}>
                  <CheckBox name={item} filterName={'Panel'} active={this.state.panelsActive.includes(item)} />
                </div>
              })}
            </div>
            }
            {subCat['line'] && <h3 className="filter-heading">Line</h3>}
            {subCat['line'] &&
              <div className="sub-filter sub-filter--lines">
                {subCat['line'] && subCat['line'].sort((a, b) => a - b).map((item) => {
                  return <div key={item}
                    onClick={
                      () => {
                        if (this.state.linesActive.includes(item)) {
                          this.setState({
                            panelsActive: [],
                            linesActive: this.state.linesActive.filter(e => e !== item)
                          }, () => props.triggerFilter(name, null, this.state.linesActive, this.state.lightActive, this.state.bifold, this.state.arch))
                        } else {
                          this.setState(prevState => ({
                            panelsActive: [],
                            linesActive: [item, ...prevState.linesActive]
                          }), () => props.triggerFilter(name, null, this.state.linesActive, this.state.lightActive, this.state.bifold, this.state.arch))
                        }
                      }}>
                    <CheckBox name={item} filterName={'Line'} active={this.state.linesActive.includes(item)} />
                  </div>
                })}
              </div>}
            {subCat['bifold'] && <h3 className="filter-heading">Bi-Fold</h3>}
            {subCat['bifold'] &&
              <div className="sub-filter sub-filter--bifold"
                onClick={() => {
                  this.setState({
                    bifold: !this.state.bifold
                  }, () => props.triggerFilter(name, this.state.panelsActive, this.state.linesActive, this.state.lightActive, this.state.bifold, this.state.arch))
                }}>
                <CheckBox name={'Bi-Fold'} active={this.state.bifold} />
              </div>
            }
            {subCat['arch'] && <h3 className="filter-heading">Arch Top</h3>}
            {subCat['arch'] &&
              <div className="sub-filter sub-filter--arch"
                onClick={() => {
                  this.setState({
                    arch: !this.state.arch
                  }, () => props.triggerFilter(name, this.state.panelsActive, this.state.linesActive, this.state.lightActive, this.state.bifold, this.state.arch))
                }}>
                <CheckBox name={'Arch Top'} active={this.state.arch} />
              </div>
            }
          </div>
        }
      </div>
    );
  }
}

export default FilterItem;
